export default {
  companyFeedMetadata: {
    lastAnswer: 'Last answer',
    sent: 'Sent',
    question: 'Question',
    loadMore: 'Load more',
    showMore: 'Show more',
    all: 'All',
    statisticInterval: 'Data for the last 60 days',
    nothingFound: 'Nothing was found for the selected period. Try to change the period',
    successMessages: {
      noMore: 'All answers for this period have been received',
    },
    errorMessages: {
      load: 'Failed to load feed',
    },
  },
};
